import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Phone, Mail, MapPin, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_elite-services-29/artifacts/3lxe01bx_IMG_2710.jpeg";

const SERVICE_LINKS = [
  ["Detailing", "/services/detailing"],
  ["Cleaning", "/services/cleaning"],
  ["Chauffeur", "/services/chauffeur"],
  ["Concierge", "/services/concierge"],
  ["Photography", "/services/photography"],
  ["Property", "/services/property-maintenance"],
  ["Removals", "/services/removals"],
  ["Catering", "/services/catering"],
];

const QUICK_LINKS = [
  ["Home", "/"], ["About Us", "/about"], ["Services", "/services"],
  ["Membership", "/membership"], ["Booking", "/book"],
  ["Partners", "/partners"], ["Contact", "/contact"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#F5EFE4] border-t border-black/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <img src={LOGO_URL} alt="Luxor" className="h-16 w-auto" style={{ mixBlendMode: "darken", filter: "brightness(1.08) contrast(1.05)" }} />
          <p className="mt-6 text-sm text-[#4A453E] leading-relaxed max-w-xs">
            Delivering exceptional lifestyle, business and property services with discretion, integrity, and excellence.
          </p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Facebook, Linkedin].map((I, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-black/15 flex items-center justify-center text-[#1A1815] hover:bg-[#1A1815] hover:text-[#F5EFE4] transition-colors" aria-label="social">
                <I size={14} />
              </a>
            ))}
          </div>
        </div>
        <div className="md:col-span-2">
          <p className="overline">Quick Links</p>
          <ul className="mt-5 space-y-2.5">
            {QUICK_LINKS.map(([label, to]) => (
              <li key={to}><Link to={to} className="text-sm text-[#1A1815] hover:text-[#C5A059] transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="overline">Our Services</p>
          <ul className="mt-5 grid grid-cols-2 gap-y-2.5 gap-x-4">
            {SERVICE_LINKS.map(([label, to]) => (
              <li key={to}><Link to={to} className="text-sm text-[#1A1815] hover:text-[#C5A059] transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="overline">Contact</p>
          <ul className="mt-5 space-y-3 text-sm text-[#1A1815]">
            <li className="flex items-start gap-3">
              <Phone size={14} className="text-[#C5A059] mt-1" />
              <a href="tel:+441234567890" className="hover:text-[#C5A059] transition-colors">+44 1234 567 890</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={14} className="text-[#C5A059] mt-1" />
              <a href="mailto:info@luxorservicesconcierge.com" className="hover:text-[#C5A059] transition-colors break-all">info@luxorservicesconcierge.com</a>
            </li>
            <li className="flex items-start gap-3"><MapPin size={14} className="text-[#C5A059] mt-1" /><span>London, United Kingdom</span></li>
            <li className="flex items-start gap-3"><Clock size={14} className="text-[#C5A059] mt-1" /><span>9am – 9pm · Mon – Sun</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#4A453E]">
          <span>© {new Date().getFullYear()} Luxor Services &amp; Concierge. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-[#C5A059]">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#C5A059]">Terms &amp; Conditions</Link>
            <Link to="/cookies" className="hover:text-[#C5A059]">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
